<template>
  <div>
    <!-- Map title -->
    <div v-if="plantDetails != null" class="plant-name-map pl-3 pt-3">
      <b-row>
        <b-col cols="10">
          <div class="bold-18">{{lastPlantName}}</div>
          <div class="typo-label">{{lastPlantAddress}}</div>
        </b-col>
        <b-col cols="2">
          <b-button v-b-modal.modal-edit-plant>
            <i class="fa fa-edit"></i>
          </b-button>
        </b-col>
      </b-row>

      <br />
    </div>

    <!---Map-->
    <iframe
      class="embed-responsive-item"
      :src="mapUrl"
      frameborder="0"
      style="border:0;"
      allowfullscreen="false"
    ></iframe>

    <!-- Edit Map Modal -->
    <b-modal v-if="plantDetails != null"
      ref="modal"
      id="modal-edit-plant"
      :saveSubmit="saveSubmit"
      :title="$t('edit_plant_modal.title')"
      :ok-title="$t('edit_plant_modal.button_plant_save')"
      :cancel-title="$t('edit_plant_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-form-group>
        <label for="label-plant-name">{{$t("edit_plant_modal.label_plant_name")}}</label>
        <b-form-input v-model="plantName" type="text" :state="validation_plantName"></b-form-input>
        <b-form-invalid-feedback
          :state="validation_plantName"
        >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <b-row>
          <b-col sm="8">
            <b-form-group>
              <label for="label-plant-street">{{$t("edit_plant_modal.label_plant_street")}}</label>
              <b-form-input
                v-model="plantStreet"
                type="text"
                :state="validation_plantStreet"
                id="placeholder-plant-street"
                :placeholder="$t('edit_plant_modal.placeholder_plant_street')"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="validation_plantStreet"
              >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="label-plant-number">{{$t("edit_plant_modal.label_plant_number")}}</label>
              <b-form-input
                v-model="plantNumber"
                type="text"
                :state="validation_plantNumber"
                id="placeholder-plant-number"
                :placeholder="$t('edit_plant_modal.placeholder_plant_number')"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="validation_plantNumber"
              >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <label for="label-plant-city">{{$t("edit_plant_modal.label_plant_city")}}</label>
            <b-form-input
              v-model="plantCity"
              type="text"
              :state="validation_plantCity"
              id="placeholder-plant-city"
              :placeholder="$t('edit_plant_modal.placeholder_plant_city')"
            ></b-form-input>
            <b-form-invalid-feedback
              :state="validation_plantCity"
            >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <label for="label-plant-cap">{{$t("edit_plant_modal.label_plant_cap")}}</label>
            <b-form-input
              v-model="plantCap"
              type="text"
              :state="validation_plantCap"
              id="placeholder-plant-cap"
              :placeholder="$t('edit_plant_modal.placeholder_plant_cap')"
            ></b-form-input>
            <b-form-invalid-feedback
              :state="validation_plantCap"
            >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group>
        <b-row>
          <b-col sm="8">
            <b-form-group>
              <label for="label-plant-prov">{{$t("edit_plant_modal.label_plant_prov")}}</label>
              <b-form-input
                v-model="plantProv"
                type="text"
                :state="validation_plantProv"
                id="placeholder-plant-prov"
                :placeholder="$t('edit_plant_modal.placeholder_plant_prov')"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="validation_plantProv"
              >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <label for="label-plant-country">{{$t("edit_plant_modal.label_plant_country")}}</label>
              <b-form-select v-model="plantCountry" :country="country">
                <option :value="null">{{$t("edit_plant_modal.placeholder_plant_country")}}</option>
                <option value="AF">Afghanistan</option>
                <option value="AX">Åland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia, Plurinational State of</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">Congo, the Democratic Republic of the</option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Côte d'Ivoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curaçao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and McDonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">Korea, Democratic People's Republic of</option>
                <option value="KR">Korea, Republic of</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Réunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthélemy</option>
                <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin (French part)</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten (Dutch part)</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS">South Georgia and the South Sandwich Islands</option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan, Province of China</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="US">United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela, Bolivarian Republic of</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.S.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col  sm="8">
            <label>{{$t("edit_plant_modal.label_plant_type")}}</label>
            <span > <strong> {{$t(plantDetails.plant_type)}}</strong></span>

            <div  class="mt-5 ml-5">
              Passa a
              <img src="img\pro.png" width="40" />
            </div>
          </b-col>
        </b-row>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PlantMap",
  data() {
    return {
      plantName: "",
      plantStreet: "",
      plantNumber: "",
      plantCity: "",
      plantCap: "",
      plantProv: "",
      plantCountry: "IT",
      country: null,
      saveSubmit: "false"
    };
  },
  computed: {
    lastPlantName() {
      if (this.$store.state.userLastPlants == null || this.$store.state.userLastPlants.length == 0) return "";
      this.plantName = this.$store.state.userLastPlants[0].plantname;
      return this.plantName;
    },
    isPro() {
        const plant = this.$store.state.currentPlant;
        if (plant == null) return false;
        return (plant.plant_type == 'pro' || plant.plant_type == 'premium');
    },
    plantDetails() {
        const plant = this.$store.state.currentPlant;
        if (plant == null) return null;
        if (plant.id != this.plantId) return null;
        return plant;
    },
    lastPlantAddress() {
      if (this.$store.state.userLastPlants == null || this.$store.state.userLastPlants.length == 0) return "";
      const addr = this.$store.state.userLastPlants[0].address;
      return (
        addr.street +
        " " +
        addr.housenumber +
        " - " +
        addr.city +
        " (" +
        addr.prov +
        ")"
      );
    },
    mapUrl() {
      if (this.$store.state.userLastPlants == null || this.$store.state.userLastPlants.length == 0) return "";
      const addr = this.$store.state.userLastPlants[0].address;
      let address = encodeURIComponent(
        addr.street + " " + addr.housenumber + "," + addr.city + "," + addr.prov
      );
      console.log("Address for map: " + address);
      const lang = this.$i18n.locale;
      return (
        "https://www.google.com/maps/embed/v1/place?key=AIzaSyA6H9RzOQ2pVsgi7rULzhkJWjDUbGJZwmE&q=" +
        address +
        "&zoom=15" +
        "&language=" + lang
      );
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    lastPlantName() {
      if (this.$store.state.userLastPlants == null || this.$store.state.userLastPlants.length == 0) return "";
      return this.$store.state.userLastPlants[0].plantname;
    },
    lastPlantAddress() {
      if (this.$store.state.userLastPlants == null || this.$store.state.userLastPlants.length == 0) return "";
      const addr = this.$store.state.userLastPlants[0].address;
      return (
        addr.street +
        " " +
        addr.housenumber +
        " - " +
        addr.cap +
        " " +
        addr.city +
        " (" +
        addr.prov +
        ")"
      );
    },
    validation_plantName() {
      if (this.saveSubmit == true) return this.plantName.length > 0;
    },
    validation_plantStreet() {
      if (this.saveSubmit == true) return this.plantStreet.length > 0;
    },
    validation_plantNumber() {
      if (this.saveSubmit == true) return this.plantNumber.length > 0;
    },
    validation_plantCity() {
      if (this.saveSubmit == true) return this.plantCity.length > 0;
    },
    validation_plantCap() {
      if (this.saveSubmit == true) return this.plantCap.length > 0;
    },
    validation_plantProv() {
      if (this.saveSubmit == true) return this.plantProv.length > 0;
    },
    validation_plantCountry() {
      if (this.saveSubmit == true) return this.plantCountry.length > 0;
    }
  },
  mounted() {
    if (this.$store.state.userLastPlants == null || this.$store.state.userLastPlants.length == 0) return ;
    this.plantName = this.$store.state.userLastPlants[0].plantname;
    this.plantStreet = this.$store.state.userLastPlants[0].address.street;
    this.plantNumber = this.$store.state.userLastPlants[0].address.housenumber;
    this.plantCity = this.$store.state.userLastPlants[0].address.city;
    this.plantCap = this.$store.state.userLastPlants[0].address.cap;
    this.plantProv = this.$store.state.userLastPlants[0].address.prov;
    this.plantCountry = this.$store.state.userLastPlants[0].address.country;
  },
  methods: {
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      this.savePlant();
    },
    savePlant() {
      /* if(this.plantName!="" && this.plantStreet!="" && this.plantNumber!="" && this.plantCity!="" && this.plantCap!="" && this.plantProv!="" && this.plantCountry!="")
          {
            console.log("Campi compialti correttamente, salva in DB"); 
            this.$store.dispatch("dbSavePlant",{"name":this.plantName, "street":this.plantStreet, "number":this.plantNumber,"city":this.plantCity,"cap:":this.plantCap,"prov":this.plantProv,"country":this.plantCountry});

            // Hide the modal manually
            this.$nextTick(() => {
              this.$refs.modal.hide()
             })

          }
        else
          {
            console.log("Campi vuoti");
            return;
          }  */
    }
  }
};
</script>